'use strict';

module.exports = (element, other) => element === other;